var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body text-left mt-3"},[_c('iframe',{staticClass:"video-iframe",attrs:{"src":_vm.videoURL,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }